<template>
  <div>
    <!-- digits -->
    <payment-total-listing :booking="booking" />

    <!-- buttons -->
    <v-row v-if="hasCashDeskPermission">
      <v-col class="col-12">
        <!-- fix 10.07.2020: disable payment button if booking comes from shop (.isAutoConfirmed()) -->
        <v-btn
          :disabled="
            booking.isPaid() ||
            !booking.getBookingStates().isConfirmed() ||
            booking.getBookingStates().isAutoConfirmed()
          "
          x-large
          color="success"
          class="w-100 mb-4 mt-7"
          @click="$refs.paymentModal.show()"
        >
          <!-- booking is paid -->
          <span v-if="booking.isPaid()">
            <i class="fal fa-check mr-2" />
            {{ $t('shopBackendBookingDetail.paid') }}
          </span>

          <!-- confirmed via shop but undpaid -->
          <span v-else-if="booking.getBookingStates().isAutoConfirmed()">
            {{ $t('paymentDetails.payCashFromShopForbidden') }}
          </span>

          <!-- waiting list -->
          <span v-else-if="!booking.getBookingStates().isConfirmed()">
            {{ $t('paymentDetails.changeBookingStateFirst') }}
          </span>

          <!-- unpaid mode -->
          <span v-else>
            <i class="fal fa-coin mr-2" />
            {{ $t('shopBackendBookingDetail.receivedMoney') }}
          </span>
        </v-btn>
      </v-col>

      <!-- print all tickets -->
      <v-col class="col-6 pt-0">
        <v-btn
          :disabled="!booking.isPaid()"
          x-large
          color="green"
          class="w-100 white--text"
          @click="
            $router.push({
              name: 'printTickets',
              params: { booking, previousRoute: $route },
            })
          "
        >
          <i class="fal fa-print mr-2" />
          {{ $t('shopBackendBookingDetail.printAllTickets') }}
        </v-btn>
      </v-col>

      <!-- print group receipt -->
      <v-col class="col-6 pt-0">
        <v-btn
          :disabled="!booking.isPaid()"
          x-large
          color="primary"
          class="w-100"
          @click="
            $router.push({
              name: 'groupReceipt',
              params: { booking, previousRoute: $route },
            })
          "
        >
          <i class="fal fa-users mr-2" />
          {{ $t('paymentDetails.printGroupReceipt') }}
        </v-btn>
      </v-col>
    </v-row>

    <!-- payment modal -->
    <s-modal
      ref="paymentModal"
      :size="1"
      :ok-text="$t('paymentDetails.customerPaid')"
      :header-text="$t('paymentDetails.didCustomerPaid')"
      @ok="payCash()"
    >
      <v-row>
        <v-col class="content-4">
          <span class="fal fa-coins fa-2x mr-2" />
          <span
            v-html="
              $t('paymentDetails.amountReceived', {
                amount: $options.filters.currency(
                  booking.getTotalWithoutCancelledBookingEntries()
                ),
              })
            "
          />
        </v-col>
      </v-row>
    </s-modal>
  </div>
</template>

<script>
import Booking from '../../../classes-shared/bookings/Booking'
import definitions from '../../../../definitions'
import PaymentTotalListing from '@/components-shared/booking/PaymentTotalListing'

export default {
  name: 'PaymentDetails',
  components: { PaymentTotalListing },
  props: {
    booking: {
      type: Booking,
      required: true,
    },
  },

  asyncComputed: {
    async hasCashDeskPermission() {
      if (this.$store.getters.getAppUserInstance()) {
        return await this.$store.getters
          .getAppUserInstance()
          .doIHavePermissionInTheCurrentDestinationForKey(
            definitions.permissions.frontend.FRONTEND_ACCESS_SHOP_CASH_DESK
          )
      }
      return false
    },
  },

  methods: {
    async payCash() {
      await this.booking.payCash(
        this.booking.getTotalWithoutCancelledBookingEntries()
      )

      // make the view reload
      this.$emit('paidCash')
    },
  },
}
</script>

<style scoped></style>
